module.exports = __webpack_public_path__ + "img/mobile1.6a267029.png";